import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Dialog, FlatButton } from 'material-ui';
import { isEmpty, append, isNil, either, equals, not, path, call, ifElse, always } from 'ramda';
import Search from './search';
import TableContainer from './table';
const isNilOrEmpty = either(isNil, isEmpty);

const ExistingConnections = props => {
  const {
    updateMMPartnerProp,
  } = props;
  const MMPartnerReducer = isEmpty(props.MMPartnerReducer2) ? props.MMPartnerReducer : props.MMPartnerReducer2; // fallback to reducer
  const cancelButton = (<FlatButton
    label="Cancel"
    primary
    labelStyle={{ fontWeight: '600' }}
    onTouchTap={() => updateMMPartnerProp({
      showSelectFromPartnersDialog: false,
      addPartnersMethod: '',
      filteredConnections: [],
      searchField: '',
      selectedExistingPartners: [],
    })}
  />);

  const addButton = (<FlatButton
    label={call(ifElse(
      equals(true),
        () => call(ifElse(
          equals(true),
            always('Add 1 partner'),
          always(`Add ${path(['selectedExistingPartners', 'length'], MMPartnerReducer)} partners`)
        ), equals(path(['selectedExistingPartners', 'length'], MMPartnerReducer), 1)),
      always('Add')
    ), not(isNilOrEmpty(MMPartnerReducer.selectedExistingPartners)))}
    secondary
    labelStyle={{ fontWeight: '600' }}
    onTouchTap={() => updateMMPartnerProp({
      showSelectFromPartnersDialog: false,
      showSelectMethod: false,
      showReview: true,
      filteredConnections: [],
      searchField: '',
      addPartnersMethod: '',
      partnersToSendTo: MMPartnerReducer.partnersToSendTo.concat(MMPartnerReducer.selectedExistingPartners),
      selectedExistingPartners: [],
    })}
    disabled={isNilOrEmpty(MMPartnerReducer.selectedExistingPartners)}
  />);

  const numberOfSelected = (
    <FlatButton
      label={equals(path(['selectedExistingPartners', 'length'], MMPartnerReducer), 1) ? '1 partner selected' : `${path(['selectedExistingPartners', 'length'], MMPartnerReducer)} partners selected`}
      disabled
      style={{ float: 'left' }}
      labelStyle={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.54)' }}
    />);

  const actions = [
    cancelButton,
    addButton,
  ];
  // console.log('filteredConnections', MMPartnerReducer.filteredConnections, props.check2, props.uncheck2);
  return (
    <Dialog
      open={MMPartnerReducer.showSelectFromPartnersDialog}
      autoScrollBodyContent
      actions={not(isNilOrEmpty(MMPartnerReducer.selectedExistingPartners)) ? append(numberOfSelected, actions) : actions}
      titleStyle={{ padding: '0' }}
      title={
        <div>
          {
            not(isNilOrEmpty(MMPartnerReducer.filteredConnections)) || not(isNilOrEmpty(MMPartnerReducer.searchField)) ?
              <div style={{ display: 'block', backgroundColor: '#00bcd4', color: '#ffffff', height: '50px' }}>
                <div style={{ padding: '2% 3%', float: 'left', fontSize: '20px', fontWeight: '600' }}>
                  Add From Connections
                </div>
                <div style={{ padding: '2% 3%', float: 'right', fontSize: '14px' }}>
                  {equals(path(['filteredConnections', 'length'], MMPartnerReducer), 1) ? '1 result found' : `${path(['filteredConnections', 'length'], MMPartnerReducer)} results found`}
                </div>
              </div> :
              <h4 style={{ color: '#ffffff', backgroundColor: '#00bcd4', padding: '2% 3%' }}>
                Add From Connections
              </h4>
          }
          <div style={{ clear: 'both' }}>
            <Search
              updateMMPartnerProp={updateMMPartnerProp}
              MMPartnerReducer2={props.MMPartnerReducer2}
            />
          </div>
        </div>
      }
      contentStyle={{ width: '640px' }}
      bodyStyle={{ paddingTop: '0' }}
    >
      <TableContainer
        MMPartnerReducer2={props.MMPartnerReducer2}
      />
    </Dialog>
  );
};

ExistingConnections.propTypes = {
  updateMMPartnerProp: PropTypes.func,
  check2: PropTypes.func,
  uncheck2: PropTypes.func,
  MMPartnerReducer: PropTypes.object,
  MMPartnerReducer2: PropTypes.object,
};

ExistingConnections.defaultProps = {
  MMPartnerReducer2: {},
};

const mapStateToProps = ({ marketingMaterials }) => ({
  MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
});

export default connect(mapStateToProps)(ExistingConnections);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/send-to-partners/existing/container-existing.jsx